import { useSyncExternalStore } from "react";
import type { UpdateStatus } from "./version";

export interface AppUpdateState {
  status: UpdateStatus;
  remoteBuildId: string | null;
}

const INITIAL: AppUpdateState = { status: "idle", remoteBuildId: null };
const RANK: Record<UpdateStatus, number> = { idle: 0, update: 1, urgent: 2 };

let state: AppUpdateState = INITIAL;
const listeners = new Set<() => void>();

export function getAppUpdateState(): AppUpdateState {
  return state;
}

/** Le statut ne redescend jamais : une fois une version repérée, elle reste due. */
export function reportRemoteVersion(status: UpdateStatus, remoteBuildId: string): void {
  if (status === "idle" || RANK[status] < RANK[state.status]) return;
  if (status === state.status && remoteBuildId === state.remoteBuildId) return;
  state = { status, remoteBuildId };
  listeners.forEach((listener) => listener());
}

export function subscribeAppUpdate(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useAppUpdate(): AppUpdateState {
  return useSyncExternalStore(subscribeAppUpdate, getAppUpdateState, getAppUpdateState);
}

export function resetAppUpdateStateForTests(): void {
  state = INITIAL;
  listeners.clear();
}
